<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="close"
    title="简历判断"
    width="400px"
  >
    <el-select v-model="enterpriseJudgeStatus" placeholder="请选择简历判断结果">
      <el-option label="合适" value="1"/>
      <el-option label="不合适" value="2"/>
      <el-option label="待定" value="3"/>
    </el-select>
    <div slot="footer" class="buttons">
      <el-button @click="close">取 消</el-button>
      <el-button
        :loading="isLoading"
        type="primary"
        class="blue-bg"
        @click="toResumeJudge"
      >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    resumeJudgeDialogVisible: {
      type: Boolean,
      default() {
        return false
      }
    },
    id: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      isLoading: false,
      enterpriseJudgeStatus: ''
    }
  },
  watch: {
    resumeJudgeDialogVisible(v) {
      this.dialogVisible = v
    }
  },
  created() {
    this.dialogVisible = this.resumeJudgeDialogVisible
  },
  methods: {
    close(data) {
      this.dialogVisible = false
      this.$emit('close', data)
    },
    toResumeJudge() {
      this.isLoading = true
      this.$api.JudgeDeliveryResume(
        { id: this.id, enterpriseJudgeStatus: this.enterpriseJudgeStatus },
        () => {
          this.isLoading = false
          this.$message.success('简历判断成功！')
          this.close(1)
        }
      )
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/css/buttons.scss";
.buttons {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/enterprise/browseResume/detail/resumeJudgeDialog.vue